import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// https://fkhadra.github.io/react-toastify/introduction/
// Usage:
// Import ToastComponent and put it somewhere in your page
// import { toast } from 'react-toastify';
// call toast.error or something dont just call toast('message')
// update styling color in the css file
export const ToastComponent = () => {
  return (
    <ToastContainer
      hideProgressBar
      position="top-center"
      limit={1}
      closeButton={false}
      icon={false}
    />
  );
};
